import React, { memo, useState, useMemo, useCallback } from 'react';
import { Text } from 'xpi-black-ui/Base/Typography';
import Slider, { WrapperSlider, WrapperTrack, WrapperThumb, ThumbTitle } from './styles';

function GenericSlider({ onChange, title, defaultValue, minDistance, min, max, isDisabled }) {
  const [isChanged, setIsChanged] = useState(false);

  const isMultiple = useMemo(() => defaultValue?.length > 1, [defaultValue]);
  const value = useMemo(() => (!isChanged ? defaultValue : undefined), [isChanged, defaultValue]);

  const Track = useCallback((props, state) => <WrapperTrack {...props} index={state.index} isMultiple={isMultiple} />, [isMultiple]);
  const Thumb = useCallback((props, state) => <WrapperThumb {...props} isDisabled={isDisabled}><ThumbTitle>{state.valueNow}</ThumbTitle></WrapperThumb>, [isDisabled]);

  const handleOnAfterChange = useCallback((newValue) => {
    onChange(newValue);
    setIsChanged(true);
  }, []);

  return (
    <WrapperSlider>
      {title && <Text>{title}</Text>}

      <Slider
        onAfterChange={handleOnAfterChange}
        renderTrack={Track}
        renderThumb={Thumb}
        orientation="horizontal"
        value={value}
        defaultValue={defaultValue}
        minDistance={minDistance}
        min={min}
        max={max}
        disabled={isDisabled}
        snapDragDisabled={isDisabled}
        pearling
      />
    </WrapperSlider>
  );
}

GenericSlider.defaultProps = {
  title: '',
  isDisabled: false,
};

export default memo(GenericSlider);
